module.exports = __webpack_public_path__ + "img/nmr.124be6a9.svg";